module.exports = __webpack_public_path__ + "img/thomas-william-O8RVgHW_10o-unsplash.jpg";